import type { CylinderJson } from 'contracts/PMIJson';
import type { Color, MeshBasicMaterial } from 'three';
import { Vector3, CylinderGeometry, Mesh } from 'three';

//eslint-disable-next-line no-restricted-imports
import { getDoubleSideMaterial } from '../../materials';

export const parseCylinder = (
  [
    [baseRadius, topRadius, height],
    centerPointVectorJson,
    directionVectorJson,
  ]: CylinderJson['cylinder'],
  color: Color | null,
): Mesh<CylinderGeometry, MeshBasicMaterial> => {
  const cylinder = new CylinderGeometry(
    topRadius,
    baseRadius,
    height,
    50,
    1,
    true,
  );
  cylinder
    .translate(...centerPointVectorJson)
    .lookAt(
      new Vector3(...centerPointVectorJson).add(
        new Vector3(...directionVectorJson),
      ),
    );
  return new Mesh<CylinderGeometry, MeshBasicMaterial>(
    cylinder,
    getDoubleSideMaterial(color),
  );
};
